export default __webpack_public_path__ + "f38fa6b5ed753d14ca2822394c5f287b.svg";